/* eslint-disable max-len */
import { useQuery } from '@tanstack/react-query';

import { ARTICLE_BY_GROUP } from 'src/constants/services';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

export const medicineListQueryKey = 'medicineList';

const useMedicineList = (page: number, alphabet: string) => {
	const { data, ...restAttributes } = useQuery({
		queryKey: [medicineListQueryKey, page, alphabet],
		queryFn: () => {
			return fetchApiV3Publishing({
				url: `${ARTICLE_BY_GROUP.service}/all`,
				payload: {
					start_with: alphabet,
					type: ARTICLE_BY_GROUP.model.obat,
					order: 'asc',
					order_by: 'slug',
					page: page,
					per_page: 50,
				},
			});
		}, retry: false, refetchOnWindowFocus: false, enabled: !!alphabet && alphabet.length > 0 },
	);

	return {
		data: data?.data?.records,
		meta: data?.meta,
		...restAttributes,
	};
};

export default useMedicineList;
